module.exports = __webpack_public_path__ + "img/comments.7e5c8f69.svg";